import React, { Suspense } from 'react';
// import { AnimatePresence } from 'framer-motion';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
// import { Redirect, Route, Switch } from 'react-router-dom';
// import PageAnimate from '../components/Animation/PageAnimate';
import CompactLayout from '../layout/MainLayout/index';
import { routes } from './RouteList'
import NotImplementedYet from '../views/NotImplementedYet';
import ProtectedRoutes from './ProtectedRoutes';
import AdminRoutes, { AdminRoleGate } from './AdminRoutes';
import {
    GLOBAL_ADMIN_AUTHORITIES,
    TENANT_DASHBOARD_AUTHORITIES,
    AUTH_TENANT_MANAGE_USERS,
    AUTH_TENANT_INVITE_USER,
    AUTH_TENANT_ADD_EXISTING_USER,
} from '../constants';
import TestView from "../views/TestView";
import Dashboard from "../views/Dashboard";
import AuthenticatedLandingPage from "../views/AuthenticatedLandingPage";

const GlobalAdminDashboard = React.lazy(() => import('../views/GlobalAdmin/Dashboard'));
const TenantOnboarding = React.lazy(() => import('../views/GlobalAdmin/TenantOnboarding'));
const TenantOpenSearchIndex = React.lazy(() => import('../views/GlobalAdmin/TenantOpenSearchIndex'));
const TenantAdminDashboard = React.lazy(() => import('../views/TenantAdmin/Dashboard'));
const ManageUsers = React.lazy(() => import('../views/TenantAdmin/ManageUsers'));
const InviteUser = React.lazy(() => import('../views/TenantAdmin/InviteUser'));
const UserDetail = React.lazy(() => import('../views/TenantAdmin/UserDetail'));
const AddExistingUser = React.lazy(() => import('../views/TenantAdmin/AddExistingUser'));
const UserManagement = React.lazy(() => import('../views/TenantAdmin/UserManagement'));

const IndexRoute = () => {

    console.log("=== IndexRoute Rendered ===");
    
    return (
        <>
            <Suspense
                fallback={
                    <div className="preloader-it">
                        <div className="loader-pendulums" />
                    </div>
                }>

                <CompactLayout>

                    <Routes>

                        {/* Protected routes that require authentication */}
                        <Route element={<ProtectedRoutes/>}>

                            {/* Handle landing route - this will match when coming from /landing */}
                            <Route index element={<AuthenticatedLandingPage />} />
                            <Route path='landing' element={<AuthenticatedLandingPage />} />
                            <Route path='dashboard' element={<Dashboard />} />
                            
                            <Route path='testhome' element={<NotImplementedYet message="Protected Home Page" />} />

                            {/* Admin routes */}
                            <Route path="admin">
                                <Route index element={<Navigate to="/landing" replace />} />
                                <Route path="global" element={<AdminRoutes authorities={GLOBAL_ADMIN_AUTHORITIES} />}>
                                    <Route index element={<GlobalAdminDashboard />} />
                                    <Route path="tenant-onboarding" element={<TenantOnboarding />} />
                                    <Route path="tenant-opensearch-index" element={<TenantOpenSearchIndex />} />
                                </Route>
                                <Route path="tenant" element={<AdminRoutes authorities={TENANT_DASHBOARD_AUTHORITIES} />}>
                                    <Route index element={<TenantAdminDashboard />} />
                                    <Route
                                        path="manage-users"
                                        element={
                                            <AdminRoleGate authorities={[AUTH_TENANT_MANAGE_USERS]}>
                                                <ManageUsers />
                                            </AdminRoleGate>
                                        }
                                    />
                                    <Route
                                        path="manage-users/:appUserId"
                                        element={
                                            <AdminRoleGate authorities={[AUTH_TENANT_MANAGE_USERS]}>
                                                <UserDetail />
                                            </AdminRoleGate>
                                        }
                                    />
                                    <Route
                                        path="add-user"
                                        element={
                                            <AdminRoleGate authorities={[AUTH_TENANT_ADD_EXISTING_USER]}>
                                                <AddExistingUser />
                                            </AdminRoleGate>
                                        }
                                    />
                                    <Route
                                        path="invite-user"
                                        element={
                                            <AdminRoleGate authorities={[AUTH_TENANT_INVITE_USER]}>
                                                <InviteUser />
                                            </AdminRoleGate>
                                        }
                                    />
                                    <Route path="user-management" element={<UserManagement />} />
                                </Route>
                            </Route>

                            {/* Dynamically load all PROTECTED routes from RouteList.jsx */}
                            {
                                routes.map((obj, i) => {
                                    return (obj.component) ? (
                                        <Route
                                            key={i}
                                            path={obj.path}
                                            element={<obj.component />}
                                        />
                                    ) : null;
                                })
                            }
                        </Route>

                        <Route path="not-implemented" element={<NotImplementedYet />} />

                        <Route path="*" element={<Navigate to="/error-404" state={{ from: useLocation().pathname }} />} />
                        
                    </Routes>

                </CompactLayout>

            </Suspense>
        </>
    )
}

export default IndexRoute
